import Player from "../../Models/Player";
import NetworkLogic from "../../Shared/NetworkLogic";
import UIManager from "../../Shared/UIManager";
import AudioManager from "../../Shared/AudioManager";
import {Global} from "../../Shared/Global";

const {ccclass, property} = cc._decorator;

@ccclass
export default class BindDevice extends cc.Component {

    @property(cc.Node)
    nodeBtnBind: cc.Node = null;
    @property(cc.Node)
    nodeBtnUnbind: cc.Node = null;
    @property(cc.Label)
    labBind: cc.Label = null;
    @property(cc.Node)
    passwordLayer: cc.Node = null;
    @property(cc.EditBox)
    edPassword: cc.EditBox = null

    start () {

        let data = {
            "userId" : Player.getPy("userID")
        }
        UIManager.showLoadingUI()
        NetworkLogic.userGetVisitorBindingStatus(data,function (rec) {//1,已绑定当前账号；2，已绑定其他账号；0，未绑定
            UIManager.hideLoadingUI()
            cc.log("===绑定状态rec：",rec);
            if (rec === 1){
                this.nodeBtnBind.active = false;
                this.nodeBtnUnbind.active = true;
                this.labBind.string = "已绑定当前设备";
                this.labBind.node.active = true;
            }else if (rec === 2){
                this.nodeBtnBind.active = false;
                this.nodeBtnUnbind.active = true;
                this.labBind.string = "已绑定其它设备";
                this.labBind.node.active = true;
            }else if (rec === 0){
                this.nodeBtnBind.active = true;
                this.nodeBtnUnbind.active = false;
                this.labBind.node.active = false;
            }
        }.bind(this),function () {
            UIManager.hideLoadingUI()

        }.bind(this))

    }

    onBtnBind(){
        AudioManager.playSound("button")
        let data = {
            "userId" : Player.getPy("userID")
        };
        UIManager.showLoadingUI();
        NetworkLogic.userVisitorBindingDevice(data,function (rec) {
            UIManager.hideLoadingUI();
            UIManager.showToastUI("绑定成功！",Global.ToastType.OK)
            cc.log("===绑定rec：",rec);
            this.nodeBtnBind.active = false;
            this.nodeBtnUnbind.active = true;
            this.labBind.string = "已绑定当前设备";
            this.labBind.node.active = true;
        }.bind(this),function () {
            UIManager.hideLoadingUI();

        }.bind(this))
    }

    onBtnUnbind(){
        AudioManager.playSound("button")
        //先验证密码
        this.edPassword.string = "";
        this.passwordLayer.active = true;
    }

    onPasswordLayerOk(){
        AudioManager.playSound("button");
        if (!this.edPassword.string) {
            UIManager.showToastUI("请先输入密码!",Global.ToastType.Warnning);
            return;
        }

        let data = {
            "userId" : Player.getPy("userID"),
            "pwd" : this.edPassword.string
        };
        cc.log("");
        UIManager.showLoadingUI();
        NetworkLogic.userVisitorUntieDevice(data,function (rec) {
            UIManager.hideLoadingUI();
            cc.log("===解除绑定rec：",rec);
            UIManager.showToastUI("解除绑定成功！",Global.ToastType.OK)
            this.passwordLayer.active = false;
            this.nodeBtnUnbind.active = false;
            this.labBind.node.active = false;
            this.nodeBtnBind.active = true;
        }.bind(this),function () {
            UIManager.hideLoadingUI();

        }.bind(this))
    }

    onPasswordLayerClose(){
        AudioManager.playSound("button")
        this.passwordLayer.active = false;
        this.edPassword.string = "";
    }

}
